import { useSelector } from "react-redux";
import { IonCard, IonIcon, IonItem, IonItemDivider, IonLabel, IonText } from "@ionic/react";
import { selectMessages } from "../../../store/locationShow/selectors/selectMessages";
import { documentTextOutline } from "ionicons/icons";
export const HistorySection: React.FC = () => {
  const messages = useSelector(selectMessages);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Historial</IonText>
      </h2>
      <section className="ion-padding-horizontal">
        {Object.entries(messages).length === 0 && (
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se ha encontrado actividad</IonText>
            </IonLabel>
          </IonItem>
        )}
        {Object.entries(messages).map(([key, value]: any) => (
          <article key={key}>
            <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

            {value.map((messageItem: any, index: number) => (
              <IonCard class="ion-no-margin ion-margin-bottom" key={index}>
                <IonItem
                  routerLink={`/app/rrhh/acuerdos/${messageItem.document?.id}`}
                  detail
                  lines="none"
                  key={messageItem.id}
                  button
                >
                  <IonIcon icon={documentTextOutline} slot="start"></IonIcon>
                  <IonLabel>
                    <h2>
                      <IonText style={{ fontWeight: 500, paddingRight: 5 }}>
                        {messageItem.createdBy?.name}
                      </IonText>
                      <IonText>{messageItem.text}</IonText>
                    </h2>
                    <p>
                      <small>{messageItem.document?.title}</small>
                    </p>
                  </IonLabel>
                  <IonText slot="end" class="ion-margin-end">
                    <h5>{messageItem.createdAtLegible?.time}</h5>
                  </IonText>
                </IonItem>
              </IonCard>
            ))}
          </article>
        ))}
      </section>
    </>
  );
};
